<ng-container [ngSwitch]="post?.ogType">
  <ng-container *ngSwitchCase="'article'">
    <ark-ui-og-article
      [ogUrl]="post?.ogUrl"
      [ogType]="post?.ogType"
      [ogImage]="post?.ogImage"
      [ogDescription]="post?.ogDescription"
      [ogTitle]="post?.ogTitle"
    ></ark-ui-og-article>
  </ng-container>

  <ng-container *ngSwitchCase="'website'">
    <ark-ui-og-article
      [ogUrl]="post?.ogUrl"
      [ogType]="post?.ogType"
      [ogImage]="post?.ogImage"
      [ogDescription]="post?.ogDescription"
      [ogTitle]="post?.ogTitle"
    ></ark-ui-og-article>
  </ng-container>
</ng-container>
